<template>
  <div>
    <div ref="dicomViewport" style="width: 100%; height: 300px"></div>
    <input
      type="range"
      v-model="currentImageIndex"
      :min="0"
      :max="dicomFiles.length - 1"
      @input="loadDicomImage"
    />
  </div>
</template>

<script>
import cornerstone from "cornerstone-core";
import dicomParser from "dicom-parser";
import cornerstoneWADOImageLoader from "cornerstone-wado-image-loader";

export default {
  name: "DicomComponent",
  props: ["dicoms"],
  data() {
    return {
      loaded: false,
      currentImageIndex: 0,
      dicomFiles: [],
    };
  },
  mounted() {
    const dicomViewport = this.$refs.dicomViewport;

    cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
    cornerstoneWADOImageLoader.external.dicomParser = dicomParser;

    cornerstoneWADOImageLoader.webWorkerManager.initialize({
      webWorkerPath: "/static/cornerstoneWADOImageLoaderWebWorker.js",
      taskConfiguration: {
        decodeTask: {
          initializeCodecsOnStartup: true,
        },
      },
    });

    cornerstone.enable(dicomViewport);

    this.dicomFiles = this.dicoms;
    this.loadDicomImage();
  },
  methods: {
    loadDicomImage() {
      const imageId = "wadouri:" + this.dicomFiles[this.currentImageIndex];

      cornerstone
        .loadAndCacheImage(imageId)
        .then((image) => {
          var viewport = cornerstone.getDefaultViewportForImage(
            this.$refs.dicomViewport,
            image
          );
          cornerstone.displayImage(this.$refs.dicomViewport, image, viewport);
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>


